import { Tooltip, Image, Modal, Form, Table } from "antd";

const GroupChatPresentationTable = ({ columns, data, loadingStatus}) => {
    return (
        <Table columns={columns} dataSource={data} pagination={true} />
    )
}

export default GroupChatPresentationTable;